import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VideoProp from '../propTypes/videoProp';

export default function VideoPlayer(props) {
  const { video, onVideoFinished, style, startPlaying } = props;

  const [showVideo, setShowVideo] = useState(false);
  useEffect(() => setShowVideo(true), []);

  const containerStyle = {
    ...style,
    width: '100%',
    height: '100%',
    outline: 'none',
  };
  return (
    <>
      {showVideo ? (
        <video
          controls
          autoPlay={startPlaying}
          style={containerStyle}
          src={video && video.url ? video.url : ''}
          onEnded={onVideoFinished}
        />
      ) : (
        <div style={containerStyle} />
      )}
    </>
  );
}

VideoPlayer.propTypes = {
  video: PropTypes.shape(VideoProp.propType).isRequired,
  onVideoFinished: PropTypes.func,
  style: PropTypes.shape({ width: PropTypes.number, height: PropTypes.number }),
  startPlaying: PropTypes.bool,
};

VideoPlayer.defaultProps = {
  onVideoFinished: () => null,
  style: {},
  startPlaying: false,
};
